import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="bg-cream py-20 px-4" data-id="element-89">
      <div className="max-w-5xl mx-auto" data-id="element-90">
        <FadeIn data-id="element-91">
          <div className="text-center mb-16" data-id="element-92">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-93">
              La solución: El Método{' '}
              <span className="text-terracotta" data-id="element-94">R.A.P.</span>
            </h2>
            <p className="text-xl text-brown-body max-w-3xl mx-auto" data-id="element-95">
              En lugar de luchar contra tu cuerpo con hambre, vamos a darle las
              señales químicas exactas para que "suelte" el exceso de
              inflamación. Al eliminar los 5 disparadores silenciosos y añadir
              nutrientes reparadores, apagamos la alarma de incendio de tu
              sistema digestivo en solo 3 días.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-96">
            <FadeIn delay={0.1} data-id="element-97">
              <div className="bg-white p-8 rounded-3xl shadow-sm text-center h-full border-t-4 border-terracotta" data-id="element-98">
                <div className="w-16 h-16 bg-beige rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold text-terracotta font-heading" data-id="element-99">
                  R
                </div>
                <h3 className="text-2xl font-bold text-brown-dark mb-4" data-id="element-100">
                  Reemplazar
                </h3>
                <p className="text-brown-body" data-id="element-101">
                  Sustituimos los disparadores inflamatorios ocultos por
                  alternativas deliciosas que calman tu intestino.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-102">
              <div className="bg-white p-8 rounded-3xl shadow-sm text-center h-full border-t-4 border-sage" data-id="element-103">
                <div className="w-16 h-16 bg-beige rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold text-sage font-heading" data-id="element-104">
                  A
                </div>
                <h3 className="text-2xl font-bold text-brown-dark mb-4" data-id="element-105">
                  Aliviar
                </h3>
                <p className="text-brown-body" data-id="element-106">
                  Introducimos nutrientes específicos que actúan como un bálsamo
                  para la pared intestinal irritada.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-107">
              <div className="bg-white p-8 rounded-3xl shadow-sm text-center h-full border-t-4 border-brown-dark" data-id="element-108">
                <div className="w-16 h-16 bg-beige rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold text-brown-dark font-heading" data-id="element-109">
                  P
                </div>
                <h3 className="text-2xl font-bold text-brown-dark mb-4" data-id="element-110">
                  Potenciar
                </h3>
                <p className="text-brown-body" data-id="element-111">
                  Reactivamos tu metabolismo y energía natural sin causar picos
                  de insulina ni estrés adicional.
                </p>
              </div>
            </FadeIn>
          </div>
        </FadeIn>
      </div>
    </section>;
}